"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decode = exports.encode = exports.isReference = exports.CountedOrderedSet = void 0;
const set_1 = require("./set");
Object.defineProperty(exports, "CountedOrderedSet", {
  enumerable: true,
  get: function () {
    return set_1.CountedOrderedSet;
  }
});
const references_1 = require("./references");
Object.defineProperty(exports, "isReference", {
  enumerable: true,
  get: function () {
    return references_1.isReference;
  }
});
Object.defineProperty(exports, "encode", {
  enumerable: true,
  get: function () {
    return references_1.encode;
  }
});
Object.defineProperty(exports, "decode", {
  enumerable: true,
  get: function () {
    return references_1.decode;
  }
});